<template>
  <div class="md-card md-card-timeline" :class="{ 'md-card-plain': plain }">
    <ul class="timeline" :class="{ 'timeline-simple': type === 'simple' }">
      <slot></slot>
    </ul>
  </div>
</template>
<script>
export default {
  name: "time-line",
  props: {
    plain: Boolean,
    type: {
      type: String,
      default: "",
    },
  },
};
</script>
<style></style>
